export default __webpack_public_path__ + "static/media/header-img.b9e8e720.png";